module.exports = __webpack_public_path__ + "static/media/3785.3f3f24d9.jpg";